const tw = {
  message: {
    Save_cmd: '存檔',
    Cancel_cmd: '取消',
    Close_cmd: '關閉視窗',
    Edit_cmd: '編輯',
    Del_cmd: '刪除',
    Query_cmd: '查詢',
    Send_cmd: '確認送出',
    Sign_in: '登入',
    Confirm_txt: '確定',
    Load_txt: '載入中',
    Error_txt: '錯誤',
    Success_txt: '成功',
    Warning_txt: '警告',
    Info_txt: '消息',
    Upload_txt: '點擊上傳',
    Back_txt: '上一步',
    Next_txt: '下一步',
    Keep_txt: '資料暫存',
    Check_txt: '資料檢查',
    Contact_txt: '連絡我們',
    Home_txt: '回勤益首頁',
    Preview_txt: '上一頁',
    NextPage_txt: '下一頁'
  }
}
export default tw




// WEBPACK FOOTER //
// ./src/i18n/lang/zh_TW.js